<template>
  <div>
    <div class="header-container">
      <div class="top-line" />
      <div class="left">
        <img src="./images/logo.svg" alt />
        <i class="line"></i>
        <!-- <img src="https://static.ls.senguo.cc/static/official/img/head_logo_active.png?v=b0f9bbe641bde586e1405dfc11f6a604" alt=""> -->
        <h1>零售后台</h1>
      </div>

      <stations-select class="station-select"></stations-select>

      <div class="right-container">
        <div class="type-container">
          <div class="type-container-left">旧版后台</div>
          <div class="type-container-right" @click="navToNewPc">新版后台</div>
        </div>
        <el-popover
          placement="bottom-start"
          width="171"
          trigger="click"
          popper-class="__header__popover__class"
          ref="popper"
          @show="arrowUp = true"
          @hide="arrowUp = false"
        >
          <div class="pop-wrap">
            <div class="header-pop-content" @click="goToPassport">
              <img src="./images/user-center.svg" alt />
              <span class="center">个人中心</span>
            </div>
            <div class="header-pop-content" @click="logout">
              <img src="./images/out.svg" alt />
              <span class="out">退出</span>
            </div>
          </div>
          <ul slot="reference" :class="{ up: arrowUp }">
            <!-- <li class="logo">
                    <img src="https://static.ls.senguo.cc/static/official/img/head_logo_active.png?v=b0f9bbe641bde586e1405dfc11f6a604" alt="">
                    </li>
                    <li class="dinghuo">
                        采购配货系统
                    </li> -->
            <li class="user">
              <dl>
                <dt :class="'avatar-border-style-' + get(userInfo, 'gender')">
                  <img :src="get(userInfo, 'avatar')" alt="" />
                </dt>
                <div>
                  <dd class="text-ellipsis">{{ get(userInfo, "nickname") }}</dd>
                  <dd>{{ get(userInfo, "phone") }}</dd>
                </div>
              </dl>
            </li>
            <li class="icon-wrap">
              <i class="el-icon el-icon-arrow-down" />
            </li>
          </ul>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { get } from "lodash";
import { $fetch } from "@/api";
import { clearSenguoCookie } from "@/utils/index";
import domain from "@/config/domain";
import StationsSelect from "./stations_select.vue";

export default {
  data() {
    return {
      arrowUp: false,
    };
  },

  computed: {
    ...mapState("shop", ["userInfo"]),
    get() {
      return get;
    },
  },

  methods: {
    logout() {
      $fetch
        .post({
          url: "/staff/stafflogout",
        })
        .finally(() => {
          clearSenguoCookie(() => {
            window.location.href = domain.passport + "/#/login?oa=new_ls";
          });
        });
    },

    navToNewPc() {
      window.location.href =
        "https://ls.senguo.cc/newadmin/#/main/goods/goodStorage/goodsLibrary";
    },

    goToPassport() {
      window.location.href = domain.passport + "/#/personalCenter";
    },
  },

  components: {
    StationsSelect,
  },
};
</script>

<style lang="scss">
body {
  .__header__popover__class {
    padding: 0 !important;
    animation: popper 0.4s;
    transition: all 0.4s;

    &[aria-hidden="true"] {
      transform: translate(14px, -8px) scale(0);
    }

    &[aria-hidden="false"] {
      transform: translate(14px, -8px) scale(1);
    }
  }

  @keyframes popper {
    from {
      transform: translate(14px, -8px) scale(0);
    }
    to {
      transform: translate(14px, -8px) scale(1);
    }
  }
}
</style>

<style lang="scss" scoped>
.right-container {
  display: flex;
  align-items: center;
}
.type-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 10px;
  height: 38px;
  justify-content: space-between;
  background-color: #f7f7f7;
  border-radius: 19px;
}
.type-container-right {
  width: 80px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 14px;
  cursor: pointer;
}
.type-container-left {
  background-image: linear-gradient(270deg, #03d3c4 0%, #44e1a6 100%);
  border-radius: 17px;
  width: 80px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
}
.header-container {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 63px;
  padding-top: 3px;
  line-height: 60px;
  box-shadow: 0 0 8px 0 #9998;
  background: #fff;
  .top-line {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background: #14cc9b;
  }

  .left {
    display: flex;
    align-items: center;
    padding-left: 12px;
    line-height: 32px;
    font-size: 24px;
    color: #333;

    .line {
      display: block;
      margin-left: 12px;
      height: 4px;
      width: 4px;
      background: #999;
      border-radius: 50%;
    }

    h1 {
      margin-left: 12px;
      text-align: left;
    }
  }

  .station-select {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
    font-size: 24px;
    color: #333;
  }

  .el-popover__reference {
    margin-right: 0 !important;
    padding: 0 15px 0 8px !important;
  }

  ul {
    display: flex;
    align-items: center;
    width: 162px;
    padding: 0 14px;
    box-sizing: content-box;
    font-size: 24px;
    color: #333;
    text-align: center;
    outline: none;
    cursor: pointer;

    &::after {
      content: "";
      display: block;
      clear: both;
    }

    &:hover {
      background: rgba(0, 0, 0, 0.05);
    }

    &.up {
      .icon-wrap > .el-icon-arrow-down {
        transform: rotate(180deg);
      }
    }

    li {
      &.user {
        float: left;

        dl {
          display: flex;
          align-items: center;
          width: 138px;
          overflow: hidden;
          font-size: 14px;
          color: #333;

          dt {
            float: left;
            width: 40px;
            height: 40px;
            margin-right: 10px;
            border-radius: 50%;
            background-color: #ccc;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
            }
          }

          dd {
            width: 88px;
            height: 22px;
            line-height: 22px;
            text-align: left;
          }
        }
      }

      &.icon-wrap {
        margin-left: 10px;
        float: right;
        font-size: 14px;
        color: #000;

        .el-icon-arrow-down {
          transition: all 0.3s;
        }
      }
    }
  }
}

.pop-wrap {
  position: relative;

  .hover-mask {
    position: absolute;
    left: 0;
    right: 0;
    top: -5px;
    height: 5px;
  }
}

.header-pop-content {
  position: relative;
  height: 50px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  cursor: pointer;
  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }

  &:first-child {
    &::before {
      content: "";
      position: absolute;
      left: 10px;
      right: 10px;
      bottom: 0;
      height: 1px;
      background: #ebebeb;
    }
  }

  img {
    margin-right: 12px;
  }

  span {
    font-size: 16px;
    color: #333333;
  }

  .out {
    color: #ee5b5b;
  }
}
</style>